import React from "react";
import fp from "lodash/fp";
import { ModalProps } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "store";
import { getModals } from "store/ui/ui.reducer";
import StackableDialog from "components/stackableDialog";
import MODAL_LOOKUP from "./lookup";

export type InjectedModalProps = {
	show: boolean;
	onHide: () => void;
	dialogAs: ModalProps["dialogAs"];
	backdrop: boolean;
};

const ModalManager = () => {
	const dispatch = useDispatch();
	const modals = useSelector(getModals);

	return fp.flow(
		fp.filter("show"),
		(modals: any[]) =>
			modals &&
			modals.map((modal, i) => {
				const { modalType, show, ...modalState } = modal;
				const Modal = MODAL_LOOKUP[modalType];

				const onHide = () => {
					dispatch(uiActions.hideModal(modalType));
				};

				const _StackableDialog = (props: any) => {
					return (
						<StackableDialog {...props} onBackdropClick={onHide} />
					);
				};

				return (
					Modal && (
						<Modal
							{...modalState}
							key={modalType + i}
							show={show}
							onHide={onHide}
							dialogAs={_StackableDialog}
							backdrop={false}
						/>
					)
				);
			}),
	)(modals);
};

export default ModalManager;
